import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CustomVisitDetailsViewModel } from '../visit-details.component';

@Component({
  standalone: false,
  selector: 'lib-institutional-fields',
  templateUrl: './institutional-fields.component.html',
  styleUrls: ['./institutional-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstitutionalFieldsComponent implements OnInit {
  @Input()
  visit: CustomVisitDetailsViewModel;

  showInstitutionalFields = false;
  constructor() { }

  ngOnInit(): void {
    if (this.visit?.admissionType || this.visit?.principalProcedure || this.visit?.admittingDiagnosisCode || this.visit?.pointOfOrigin ||
      this.visit?.otherProcedure1 || this.visit?.otherProcedure2 || this.visit?.otherProcedure3 || this.visit?.otherProcedure4 ||
      this.visit?.otherProcedure5 || this.visit?.visitReason1DiagnosisCode || this.visit?.visitReason2DiagnosisCode || this.visit?.visitReason3DiagnosisCode ||
      this.visit?.dischargeStatus || this.visit?.occurrenceSpanCode1 || this.visit?.occurrenceSpanCode2 || this.visit?.cause1DiagnosisCode ||
      this.visit?.cause2DiagnosisCode || this.visit?.cause3DiagnosisCode || this.visit?.conditionCode1 || this.visit?.conditionCode2 || this.visit?.conditionCode3 ||
      this.visit?.conditionCode4 || this.visit?.conditionCode5 || this.visit?.conditionCode6 || this.visit?.conditionCode7 || this.visit?.conditionCode8 ||
      this.visit?.conditionCode9 || this.visit?.conditionCode10 || this.visit?.conditionCode11 || this.visit?.occurrenceCode1 || this.visit?.occurrenceCode2 ||
      this.visit?.occurrenceCode3 || this.visit?.occurrenceCode4 || this.visit?.drgDiagnosisCode || this.visit?.valueCode1 || this.visit?.valueCode2 ||
      this.visit?.valueCode3 || this.visit?.billingNote || this.visit?.claimNote1 || this.visit?.claimNote2 || this.visit?.claimNote3 || this.visit?.claimNote4 ||
      this.visit?.claimNote5 || this.visit?.claimNote6 || this.visit?.claimNote7 || this.visit?.claimNote8 || this.visit?.claimNote9 || this.visit?.claimNote10 ||
      this.visit?.diagnosis1 || this.visit?.diagnosis2 || this.visit?.diagnosis3 || this.visit?.diagnosis4 || this.visit?.diagnosis5 ||
      this.visit?.diagnosis6 || this.visit?.diagnosis7 || this.visit?.diagnosis8 || this.visit?.diagnosis9 || this.visit?.diagnosis10 ||
      this.visit?.diagnosis11 || this.visit?.diagnosis12 || this.visit?.attendingProvider || this.visit?.referringProvider || this.visit?.location) {
      this.showInstitutionalFields = true;
    }
  }
}
